import { createFileRoute } from '@tanstack/react-router'

import { WallAdminPage } from '@/components/pages/Admin/Wall/WallAdminPage'

export const Route = createFileRoute('/_liff/admin/wall')({
  component: WallAdminPage,
})
